import React from 'react';
import { HighlightedOfferColumn } from './styles';
import { IOfferProps } from './types';
import { HighlightedOfferRow } from '../../price-list/price-row';

const HighlightedOffer: React.FC<IOfferProps> = props => {
  const { title, ...otherProps } = props;
  return (
    <HighlightedOfferColumn>
      <HighlightedOfferRow title={title} {...otherProps} />
    </HighlightedOfferColumn>
  );
};

export default HighlightedOffer;
